// extracted by mini-css-extract-plugin
export default {"root":"style_root__3OgJj","statement":"style_statement__9O3-M","description":"style_description__3Pbs2","agree":"style_agree__3fovC","agreements":"style_agreements__cN97L"};